import React from "react";


const IconFlight = ({color}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 21">
    <path id="plane-departure_2_" 
    data-name="plane-departure(2)" 
    d="M1.067,15.411l2.075,1.477a6.169,6.169,0,0,0,3.572,1.14,6.046,6.046,0,0,0,2.612-.59l12.953-5.7a3.012,3.012,0,0,0-2.535-5.465L16.6,7.677,9.982,3.591A3,3,0,0,0,6.93,3.28l-.781.366a2,2,0,0,0-.475,3.308l4.2,3.72-3.591,1.6L3.23,11.154A2.417,2.417,0,0,0,.5,11.945a2.312,2.312,0,0,0-.462,1.776,2.527,2.527,0,0,0,1.033,1.688ZM7,5.457l.776-.364a1.05,1.05,0,0,1,1.085.151l5.531,3.418L11.886,9.78ZM2.071,13.179a.418.418,0,0,1,.334-.169c.05,0,3.574,1.285,3.574,1.285a1,1,0,0,0,.752-.025L20.564,8.1l.013-.006A1,1,0,0,1,21.9,8.58a1.023,1.023,0,0,1-.46,1.342L8.492,15.62A4.155,4.155,0,0,1,4.3,15.258L2.226,13.782a.528.528,0,0,1-.213-.348.324.324,0,0,1,.058-.256ZM24,23a1,1,0,0,1-1,1H1a1,1,0,0,1,0-2H23A1,1,0,0,1,24,23Z" 
    transform="translate(0 -3)" fill={color}/>
  </svg>
  );
};
export default IconFlight
